export default "__VITE_ASSET__rU4E3RPX__"